/* eslint-disable react/no-array-index-key */
import React from 'react';

import Render from 'components/render';
import { LoadingSkeleton } from 'UIKit/LoadingSkeleton';

import styles from './marketsLoadingSkeleton.module.scss';

const MarketsTableLoadingSkeleton = ({
  variant,
}: {
  variant: 'options_chain' | 'others';
}) => {
  return (
    (<div
      className={styles.skeletonWrapper}
      data-palette="MarketsTableLoadingSkeleton">
      <Render when={variant === 'options_chain'}>
        <div className={styles.optionsLoader1}>
          <div>
            <LoadingSkeleton as="div" width={70} height={40} animateSkeleton />
            <LoadingSkeleton as="div" width={125} height={40} animateSkeleton />
          </div>
          <div>
            <LoadingSkeleton as="div" width={30} height={40} animateSkeleton />
            <LoadingSkeleton as="div" width={125} height={40} animateSkeleton />
            <LoadingSkeleton as="div" width={60} height={40} animateSkeleton />
            <LoadingSkeleton as="div" width={135} height={40} animateSkeleton />
          </div>
        </div>
        <div className={styles.optionsLoader2}>
          <LoadingSkeleton as="div" width={130} height={20} animateSkeleton />
          <LoadingSkeleton as="div" width={130} height={20} animateSkeleton />
        </div>
      </Render>
      <div className={styles.tableSkeleton}>
        {Array.from(Array(32).keys()).map(index => (
          <LoadingSkeleton
            as="div"
            className={styles.skeleton}
            animateSkeleton
            key={index}
          />
        ))}
      </div>
    </div>)
  );
};

export default MarketsTableLoadingSkeleton;
